var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPreviewable_)?_c('div',{on:{"click":_vm.preview}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"手机壁纸预览","placement":"bottom","manual":true,"value":_vm.showTooltip}},[_c('i',{staticClass:"iconfont icon-sy-iphone",staticStyle:{"font-size":"20px"}})])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdb86d7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/WallpaperPreviewer.vue
// module id = null
// module chunks = 